import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { rem } from 'polished';

const PageHeroPlaceholder = props => (
	<Wrapper full={props.full}>
		<ContentLoader
			preserveAspectRatio="xMidYMin slice"
			width={700}
			height={700}
			speed={2}
			primaryColor="#ebecef"
			secondaryColor="#d1d2db"
			{...props}
		/>
	</Wrapper>
);

const Wrapper = styled.div`
	width: 100%;
	height: ${props => (props.full ? '85vh' : '56vh')};
	background-color: ${props => props.theme.gray1};
	position: relative;

	@media ${props => props.theme.breakpointLarge} {
		max-height: ${rem('560px')};
	}

	svg {
		width: 100%;
		height: 100%;
		position: relative;
	}
`;

export default PageHeroPlaceholder;



// WEBPACK FOOTER //
// ./src/components/ui/layout/spinner/page-hero-placeholder.jsx